export const SITE_NAME = "Gazmatek System";
export const SITE_URL = "https://gazmatek.com";
export const SITE_SHARE_IMAGE = `${SITE_URL}/shared-thumbnail.jpg`;

/**
 * Set to true to enable /:lang/* routing (e.g. /en/, /fr/).
 * Set to false for a single-language app — standard routing is used instead.
 */
export const I18N_ROUTING = true;
